import { createStringIdAdapter } from './string-id-adapter';

export const stringAdapter = createStringIdAdapter<string>();
